import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/produtos',
    name: 'Produtos',
    component: () => import( '../views/Home.vue')
  },
  {
    path: '/categorias',
    name: 'categorias',
    component: () => import( '../views/categorias.vue')
  },
  {
    path: '/',
    name: 'areas',
    component: () => import( '../views/areas.vue')
  },
  {
    path: '/familias',
    name: 'familias',
    component: () => import( '../views/familias.vue')
  },
  {
    path: '/users',
    name: 'users',
    component: () => import( '../views/users.vue')
  },
  {
    path: '/produtos-destaque',
    name: 'produtos-destaque',
    component: () => import( '../views/produtos-destaque.vue')
  },
  {
    path: '/novidades-destaque',
    name: 'novidades-destaque',
    component: () => import( '../views/novidades-destaque.vue')
  },
  {
    path: '/comunicacoes-destaque',
    name: 'comunicacoes-destaque',
    component: () => import( '../views/comunicacoes-destaque.vue')
  },
  {
    path: '/farmaletter',
    name: 'farmaletter',
    component: () => import( '../views/farmaletter.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '../views/Login.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
